import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import { DocumentoFavorito, ISdocumentoFavorito } from "../../../types/documento/favorito/DocumentoFavorito";
import { DocumentoFavoritoDTO } from "../../../types/documento/favorito/DocumentoFavoritoDTO";
import errorFormat from "../../../utils/errorFormat";
import { useCreateFavoritoDocumentoMutation, useGetDocumentoFavoritoQuery } from "./DocumentoFavoritoApiSlice";

export const DocumentoFavoritoCreateForm = () => {


    const idDocumento = useParams().id || "";
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const idFavorito = params.get('idFavorito');



   
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createFavorito, status] = useCreateFavoritoDocumentoMutation();
    const navigate = useNavigate();

    // Hook para seleção do documento
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum documento foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);


    
    const [documentoFavorito, SetDocumentoFavorito] = useState<DocumentoFavorito>(ISdocumentoFavorito);
    //const [documento, setDocumento] = useState<DocumentoFavorito>(ISdocumentoFavorito);


    const { data: dataDoc, isFetching: isFetchingDoc, error: errorDoc } = useGetDocumentoFavoritoQuery(idFavorito || "");
    useEffect(() => {
       
        if (dataDoc) {
            SetDocumentoFavorito(dataDoc);
        } else if (errorDoc) {
            enqueueSnackbar("Documento não encontrado!", { variant: "error" });
            //  window.location.href = configUrls.PROCESSO_LIST_RT;
        } else if (isFetchingDoc) {
            enqueueSnackbar("Buscando registro...", { variant: "info" });
        } else {
            enqueueSnackbar("Documento não encontrado!", { variant: "error" });
            window.location.href = configUrls.PROCESSO_LIST_RT;
        }
    }, [dataDoc, errorDoc, isFetchingDoc]);




    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        SetDocumentoFavorito((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };    

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const parms: DocumentoFavoritoDTO = {
            id: documentoFavorito.id,
            descricao: documentoFavorito.descricao,
            documentoID: idDocumento ? idDocumento : "",
        }
        await createFavorito(parms);
    }

    useEffect(() => {

       

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Criar / Atualizar Favorito do documidento: {/*documento.documento.nomeArvore*/}
                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        label="Descricão:"
                                        name="descricao"
                                        onChange={handleChange}
                                        size="small"
                                        inputProps={{ maxLength: 255 }}
                                        value={documentoFavorito.descricao}
                                        multiline  // Adiciona o suporte a múltiplas linhas
                                        rows={4} />


                                    <FormHelperText>
                                        {documentoFavorito.descricao?.length}/255 caracteres
                                    </FormHelperText>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>



                </Box>




            </Paper>










        </>







    );










};